import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import FacilityReservations from './FacilityReservations';
import PackageTracking from './PackageTracking';
import VisitorManagement from './VisitorManagement';
import Messages from './Messages';
import PackageDetailsPage from './PackageDetailsPage';
import ReservationDetailsPage from './ReservationDetailsPage';
import VisitorDetailsPage from './VisitorDetailsPage';

const ResidentsRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/facility-reservations" replace />} />
      
      {/* List Pages */}
      <Route path="/facility-reservations" element={<FacilityReservations />} />
      <Route path="/package-tracking" element={<PackageTracking />} />
      <Route path="/visitor-management" element={<VisitorManagement />} />
      <Route path="/messages" element={<Messages />} />
      
      {/* Details Pages */}
      <Route path="/packages/:id" element={<PackageDetailsPage />} />
      <Route path="/reservations/:id" element={<ReservationDetailsPage />} />
      <Route path="/visitors/:id" element={<VisitorDetailsPage />} />
      
      <Route path="*" element={<Navigate to="/facility-reservations" replace />} />
    </Routes>
  );
};

export default ResidentsRouter; 